// Strip HTML to plain text — used for card/excerpt views where rich-text descriptions
// must not leak markup. Uses the DOM when available, with a regex fallback.
export function stripHtml(html?: string | null): string {
  if (!html) return '';
  if (typeof document !== 'undefined') {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
  }
  return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}
